import {getConfig, getConfigItem, setConfigItem, observeConfigItem} from './config';
import * as configConstants from './constants';

globalThis.nowUiFramework = globalThis.nowUiFramework || {};
globalThis.nowUiFramework.getConfig = getConfig;
globalThis.nowUiFramework.getConfigItem = getConfigItem;
globalThis.nowUiFramework.setConfigItem = setConfigItem;
globalThis.nowUiFramework.observeConfigItem = observeConfigItem;

export {configConstants, getConfig, getConfigItem, setConfigItem, observeConfigItem};
